// https://github.com/porsche-design-system/porsche-design-system/blob/main/packages/assets/projects/fallbacks/src/browser-support/browser-support-utils.ts
export const hasPorscheDesignSystemBrowserSupport = (): boolean => {
  return !['IntersectionObserver', 'MutationObserver', 'customElements'].some(
    (x) => !(x in window),
  );
};
